<template>
  <div id="care">
    <!-- 로더 -->
    <loader v-if="loaderActive"></loader>
    <section id="hero">
      <div class="container">
        <p>비즈케어</p>
        <h1 class="title">비즈해줌과 파트너가 되세요 <br>시공의 집중도가 달라집니다</h1>
      </div>
    </section>
    <section id="single">
      <div class="container">
        <h2 class="section-title">단일 유지관리 <br class="visible-xs">제공 서비스</h2>
        <div class="notice">
          <img src="~@/assets/svg/ic-question.svg">
          <p class="notice">원하는 서비스를 선택하세요.</p>
        </div>
        <ul class="row">
          <li class="col-md-push-1 col-md-10 col-xs-12">
            <div :class="['table', {'active': setActiveClass(checkedSingleService, 'module')}]" @click.prevent="toggleSingleService('module')">
              <div class="checkbox table-cell">
                <label>
                  <input type="checkbox" value="module" v-model="checkedSingleService">
                  <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                </label>
              </div>
              <h4 class="name table-cell">모듈 청소</h4>
              <p class="description table-cell">발전소 효율을 높이고 싶다면 주기적인 모듈 세척이 필수입니다.</p>
            </div>
          </li>
          <li class="col-md-push-1 col-md-10 col-xs-12">
            <div :class="['table', {'active': setActiveClass(checkedSingleService, 'drone')}]" @click.prevent="toggleSingleService('drone')">
              <div class="checkbox table-cell">
                <label>
                  <input type="checkbox" value="drone" v-model="checkedSingleService">
                  <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                </label>
              </div>
              <h4 class="name table-cell">드론 열화상 점검</h4>
              <p class="description table-cell">MW급 대용량 태양광 발전소라면, 드론 열화상 촬영으로 더 효율적이고 <br class="hidden-xs">과학적으로 점검해야 합니다.</p>
            </div>
          </li>
          <li class="col-md-push-1 col-md-10 col-xs-12">
            <div :class="['table', {'active': setActiveClass(checkedSingleService, 'accounting')}]" @click.prevent="toggleSingleService('accounting')">
              <div class="checkbox table-cell">
                <label>
                  <input type="checkbox" value="accounting" v-model="checkedSingleService">
                  <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                </label>
              </div>
              <h4 class="name table-cell">회계대행</h4>
              <p class="description table-cell">태양광 발전소에 꼭 필요한 회계 처리, 태양광 업계 전문 지식을 보유한 회계사를 <br class="hidden-xs hidden-sm">지원해 드립니다.</p>
            </div>
          </li>
        </ul>
        <form v-show="checkedSingleService.length > 0" class="row" @submit.prevent="validate('single')">
          <div class="col-md-push-2 col-md-4 col-sm-6 form-group">
            <label>담당자명</label>
            <input type="text"
                   class="hz-input-default hz-input-lg"
                   maxlength="20"
                   data-vv-name="name"
                   v-validate="{required: true}"
                   v-model.trim="applicant.name"
                   placeholder="예) 홍길동">
            <p class="is-invalid-text">{{ errors.first('name') }}</p>
          </div>
          <div class="col-md-push-2 col-md-4 col-sm-6 form-group">
            <label>담당자 연락처</label>
            <input-phone :class="['hz-input-default', 'hz-input-lg', {'is-invalid': errors.first('contact')}]"
                         :placeholder="'예) 010-1234-5678'"
                         data-vv-name="contact"
                         v-validate="{required: true, regex: '^\\d{3}-\\d{3,4}-\\d{4}$'}"
                         v-model.trim="applicant.contact"></input-phone>
            <p class="is-invalid-text">{{ errors.first('contact') }}</p>
          </div>
          <div class="col-xs-12 text-center">
            <button type="submit" class="hz-btn-primary hz-btn-lg">신청하기</button>
          </div>
        </form>
      </div>
    </section>
    <section id="integrated">
      <div class="container">
        <h2 class="section-title">통합 유지관리 <br class="visible-xs">제공 서비스</h2>
        <div class="notice">
          <img src="~@/assets/svg/ic-question.svg">
          <p class="notice">원하는 서비스를 선택하세요.</p>
        </div>
        <ul class="row">
          <li class="col-md-4">
            <div :class="['card', {'active': setActiveClass(checkedIntegratedService, 'home')}]">
              <div class="card-header" @click.prevent="toggleIntegratedService('home')">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" value="home" v-model="checkedIntegratedService">
                    <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                  </label>
                </div>
                <div class="icon">
                  <img src="~@/assets/svg/ic-care-home.svg" class="img-responsive">
                </div>
                <div class="contents">
                  <h4>주택용</h4>
                  <p>단독주택에 설치된 모든 태양광</p>
                </div>
              </div>
              <div class="line"></div>
              <div id="home" class="card-body collapse" @click.prevent="toggleIntegratedService('home')">
                <p class="bold">전체점검</p>
                <p class="margin-bottom-16">DC라인 이상(모듈, 접속반) 점검・ 조치,  인버터 점검, 구조물 및 기초패드점검, AC라인 및 기자재 점검 ・ 조치</p>
                <p class="bold margin-bottom-16">퓨즈, 차단기, 접속반, 인버터 교체</p>
                <p class="bold margin-bottom-16">DC라인 ・ AC라인 수리</p>
                <p class="bold">구조물 및 기초패드 보강</p>
              </div>
              <div class="card-footer">
                <a href="#"  @click.prevent="moreInfoHome = !moreInfoHome"
                   data-toggle="collapse" data-target="#home" aria-expanded="false" aria-controls="home">
                  {{ moreInfoHome | setBtnText }}
                  <img v-show="moreInfoHome" src="~@/assets/svg/ic-arrow-up.svg">
                  <img v-show="!moreInfoHome" src="~@/assets/svg/ic-arrow-down.svg">
                </a>
              </div>
            </div>
          </li>
          <li class="col-md-4">
            <div :class="['card', {'active': setActiveClass(checkedIntegratedService, 'small')}]">
              <div class="card-header" @click.prevent="toggleIntegratedService('small')">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" value="small" v-model="checkedIntegratedService">
                    <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                  </label>
                </div>
                <div class="icon">
                  <img src="~@/assets/svg/ic-care-plant-small.svg" class="img-responsive">
                </div>
                <div class="contents">
                  <h4>소규모</h4>
                  <p>500kW미만 발전소</p>
                </div>
              </div>
              <div class="line"></div>
              <div id="small" class="card-body collapse"  @click.prevent="toggleIntegratedService('small')">
                <p class="bold">전수검사</p>
                <p class="margin-bottom-16">전수검사 ・ 전수검사 보고서</p>
                <p class="bold">수리 및 교체</p>
                <p class="margin-bottom-16">DC라인, 접속반 ・ 인버터, ACB반, 한전라인, 시공부지, 기자재, 통신</p>
                <p class="bold">회계</p>
                <p class="margin-bottom-16">SMP  ・ REC 거래, 회계 처리, 기장 등</p>
                <p class="bold">기타</p>
                <p class="margin-bottom-16">보험가입, 안전관리자, 모듈 청소, 드론 열화상 점검</p>
              </div>
              <div class="card-footer">
                <a href="#" @click.prevent="moreInfoSmall = !moreInfoSmall"
                   data-toggle="collapse" data-target="#small" aria-expanded="false" aria-controls="small">
                  {{ moreInfoSmall | setBtnText }}
                  <img v-show="moreInfoSmall" src="~@/assets/svg/ic-arrow-up.svg">
                  <img v-show="!moreInfoSmall" src="~@/assets/svg/ic-arrow-down.svg">
                </a>
              </div>
            </div>
          </li>
          <li class="col-md-4">
            <div :class="['card', {'active': setActiveClass(checkedIntegratedService, 'large')}]">
              <div class="card-header" @click.prevent="toggleIntegratedService('large')">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" value="large" v-model="checkedIntegratedService">
                    <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                  </label>
                </div>
                <div class="icon">
                  <img src="~@/assets/svg/ic-care-plant-large.svg" class="img-responsive">
                </div>
                <div class="contents">
                  <h4>대규모</h4>
                  <p>500kW이상 발전소</p>
                </div>
              </div>
              <div class="line"></div>
              <div id="large" class="card-body collapse" @click.prevent="toggleIntegratedService('large')">
                <p class="margin-bottom-16" style="color: #adb5bd; font-weight: bold;">기본 종합관리</p>
                <p class="bold">전수검사</p>
                <p class="margin-bottom-16">전수검사 ・ 전수검사 보고서</p>
                <p class="bold">수리 및 교체</p>
                <p class="margin-bottom-16">DC라인, 접속반 ・ 인버터, ACB반, 한전라인, 시공부지, 기자재, 통신</p>
                <p class="bold">회계</p>
                <p class="margin-bottom-16">SMP  ・ REC 거래, 회계 처리, 기장 등</p>
                <p class="bold">기타</p>
                <p class="margin-bottom-16">발전사업 보험가입, 무선 통신망 설치</p>
                <div class="options">
                  <p style="margin: 0 0 8px 0;">선택 옵션 관리</p>
                  <p class="bold margin-0">안전관리자 선임, 모듈 청소, 드론 열화상카메라 점검</p>
                </div>
              </div>
              <div class="card-footer">
                <a href="#" @click.prevent="moreInfoLarge = !moreInfoLarge" :class="[{'bg-pale-grey': moreInfoLarge}]"
                   style="border-color: #f8f9fa;" data-toggle="collapse" data-target="#large" aria-expanded="false" aria-controls="large">
                  {{ moreInfoLarge | setBtnText }}
                  <img v-show="moreInfoLarge" src="~@/assets/svg/ic-arrow-up.svg">
                  <img v-show="!moreInfoLarge" src="~@/assets/svg/ic-arrow-down.svg">
                </a>
              </div>
            </div>
          </li>
        </ul>
        <form v-show="checkedIntegratedService.length > 0" class="row" @submit.prevent="validate('integrated')">
          <div class="col-md-push-2 col-md-4 col-sm-6 form-group">
            <label>담당자명</label>
            <input type="text"
                   class="hz-input-default hz-input-lg"
                   maxlength="20"
                   data-vv-name="name"
                   v-validate="{required: true}"
                   v-model.trim="applicant.name"
                   placeholder="예) 홍길동">
            <p class="is-invalid-text">{{ errors.first('name') }}</p>
          </div>
          <div class="col-md-push-2 col-md-4 col-sm-6 form-group">
            <label>담당자 연락처</label>
            <input-phone :class="['hz-input-default', 'hz-input-lg', {'is-invalid': errors.first('contact')}]"
                         :placeholder="'예) 010-1234-5678'"
                         data-vv-name="contact"
                         v-validate="{required: true, regex: '^\\d{3}-\\d{3,4}-\\d{4}$'}"
                         v-model.trim="applicant.contact"></input-phone>
            <p class="is-invalid-text">{{ errors.first('contact') }}</p>
          </div>
          <div class="col-xs-12 text-center">
            <button type="submit" class="hz-btn-primary hz-btn-lg">신청하기</button>
          </div>
        </form>
      </div>
    </section>
    <section id="banner">
      <div class="container">
        <router-link to="/insurance">
          <img alt="비즈해줌 보험대행 서비스 안내 배너"
               src="~@/assets/img/care/img-care-banner-xs.jpg"
               class="img-responsive img-small">
          <img alt="비즈해줌 보험대행 서비스 안내 배너"
               src="~@/assets/img/care/img-care-banner.jpg"
               srcset="~@/assets/img/care/img-care-banner@2x.jpg 2x, ~@/assets/img/care/img-care-banner@3x.jpg 3x"
               class="img-responsive img-large">
        </router-link>
      </div>
    </section>
    <section v-if="user.id" id="applyList">
      <div class="container">
        <div class="row">
          <h4 class="col-xs-12">신청목록</h4>
          <div class="col-xs-12">
            <kendo-grid ref="grid"
                        :columns="tableFields"
                        :options="tableOptions"
                        :auth="true"
                        :dataUrl="applyListUrl"
                        :message="'신청내역이 없습니다.'">
            </kendo-grid>
          </div>
        </div>
      </div>
    </section>
    <!-- 로그인 알림창 -->
    <modal ref="loginModal" :id="loginModal.id" :type="loginModal.type" :title="loginModal.title" :size="loginModal.size" :fields="loginModal.fields" @submit="$router.push({name: 'login'}); $route.query.next = {name: 'care'}"></modal>
    <!-- 서비스 신청 확인창 -->
    <modal ref="applyModal" :id="applyModal.id" :type="applyModal.type" :title="applyModal.title" :size="applyModal.size" :fields="applyModal.fields" @submit="applyBizcare(applyModal.param)"></modal>
  </div>
</template>

<script>
  import api from '@/api/onm'
  import Loader from 'common/components/Loader'
  import InputPhone from 'common/components/InputPhone'
  import Modal from 'common/components/Modal'
  import KendoGrid from 'common/components/KendoGrid'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'care',
    components: { Loader, InputPhone, Modal, KendoGrid },
    data () {
      return {
        loaderActive: false,
        applyListUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/bizcare/',
        applicant: {
          name: '',
          contact: ''
        },
        serviceNameObj: {
          module: '모듈 청소',
          drone: '드론 열화상 점검',
          accounting: '회계대행',
          home: '주택용',
          small: '소규모',
          large: '대규모'
        },
        checkedSingleService: [],
        checkedIntegratedService: [],
        moreInfoHome: false,
        moreInfoSmall: false,
        moreInfoLarge: false,
        tableFields: [
          {
            field: 'reg_date',
            title: '신청일',
            type: 'date',
            format: '{0:yyyy.MM.dd}',
            width: '120px',
            sortable: false,
            filterable: false
          },
          {
            field: 'name',
            title: '담당자명',
            type: 'string',
            width: '120px',
            sortable: false,
            filterable: false
          },
          {
            field: 'contact',
            title: '담당자 연락처',
            type: 'string',
            width: '140px',
            sortable: false,
            filterable: false
          },
          {
            field: 'single_service',
            title: '단일 유지관리',
            type: 'string',
            width: '250px',
            sortable: false,
            filterable: false
          },
          {
            field: 'integrated_service',
            title: '통합 유지관리',
            type: 'string',
            width: '180px',
            sortable: false,
            filterable: false
          },
          {
            field: 'step',
            title: '진행단계',
            type: 'string',
            width: '100px',
            sortable: false,
            filterable: false
          }
        ],
        tableOptions: {
          parameter: [
            { name: 'all_check', value: 'N' }
          ],
          pageable: {
            info: true,
            previousNext: true,
            numeric: true,
            pageSize: 50,
            pageSizes: [20, 50, 100, 'all'],
            refresh: true,
            buttonCount: 5,
            messages: {
              itemsPerPage: '페이지당 항목수'
            }
          }
        },
        loginModal: {
          id: 'loginModal',
          type: 'confirm',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['로그인이 필요한 서비스입니다.', '로그인화면으로 이동하시겠습니까?'],
              class: 'text-center'
            }
          ]
        },
        applyModal: {
          id: 'applyModal',
          type: 'confirm',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['선택한 서비스를 문의하시겠습니까?'],
              class: 'text-center'
            }
          ]
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      })
    },
    watch: {
      'user': {
        handler () {
          this.setApplicantInfo()
        }
      },
      'checkedSingleService': {
        handler (val) {
          // 단일, 통합 유지관리 항목이 동시 선택 안되도록 처리한다.
          const checkedSingle = val.length > 0
          const checkedIntegrated = this.checkedIntegratedService.length > 0

          // 단일 유지관리가 선택 && 통합 유지관리가 선택 되어있을 경우, 통합 유지관리 항목을 초기화한다.
          if (checkedSingle && checkedIntegrated) {
            this.checkedIntegratedService = []
            this.errors.clear()
            $(this.$el).find('.is-invalid').removeClass('is-invalid')
          }
        }
      },
      'checkedIntegratedService': {
        handler (val) {
          // 단일, 통합 유지관리 항목이 동시 선택 안되도록 처리한다.
          const checkedIntegrated = val.length > 0
          const checkedSingle = this.checkedSingleService.length > 0

          // 통합 유지관리가 선택 && 단일 유지관리가 선택 되어있을 경우, 통합 유지관리 항목을 초기화한다.
          if (checkedIntegrated && checkedSingle) {
            this.checkedSingleService = []
            this.errors.clear()
            $(this.$el).find('.is-invalid').removeClass('is-invalid')
          }
        }
      }
    },
    filters: {
      setBtnText (bool) {
        return bool ? '닫기' : '자세히 보기'
      }
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      setActiveClass (list = [], id = '') {
        // 서비스 리스트 클릭 시, 서비스 목록에 값 유무를 확인하여 active 클래스를 할당한다.
        const index = _.findIndex(list, (o) => {
          return o === id
        })

        return index !== -1
      },
      setApplicantInfo () {
        // 신청자에 기본 정보를 설정해준다. (담당자명, 담당자 연락처)
        this.applicant = {
          name: this.user.pic_name,
          contact: this.user.pic_contact
        }
      },
      toggleSingleService (id = '') {
        // 로그인 여부 확인
        if (!this.user.isLogin) {
          this.$refs.loginModal.show()
          return false
        }

        // 단일 유지관리 서비스 선택 시, 체크박스 값을 관리하는 리스트를 업데이트 한다.
        const list = this.checkedSingleService
        const index = _.findIndex(list, (o) => { return o === id })
        const hasValue = index !== -1

        // 리스트에 값 유무에 따라 값을 추가 또는 삭제해준다.
        if (hasValue) {
          this.checkedSingleService.splice(index, 1)
        } else {
          this.checkedSingleService.push(id)
        }
      },
      toggleIntegratedService (id = '') {
        // 로그인 여부 확인
        if (!this.user.isLogin) {
          this.$refs.loginModal.show()
          return false
        }

        // 통합 유지관리 서비스 선택 시, 체크박스 값을 관리하는 리스트를 업데이트 한다.
        const list = this.checkedIntegratedService
        const index = _.findIndex(list, (o) => { return o === id })
        const hasValue = index !== -1

        // 리스트에 값 유무에 따라 값을 추가 또는 삭제해준다.
        if (hasValue) {
          this.checkedIntegratedService.splice(index, 1)
        } else {
          this.checkedIntegratedService.push(id)
        }
      },
      validate (type) {
        // 유효성 검증 후, 에러 여부에 따라 동작을 구분한다.
        this.$validator.validateAll()

        this.$nextTick(() => {
          if (!this.errors.any()) {
            this.applyModal.param = type
            this.$refs.applyModal.show()
          }
        })
      },
      setServiceData (list = []) {
        // 선택된 서비스 항목을 한글로 변환해 반환한다.
        const obj = this.serviceNameObj
        const nameList = []

        for (let i in list) {
          const name = obj[list[i]]
          nameList.push(name)
        }

        return nameList.toString()
      },
      scrollToApplyList () {
        const position = document.getElementById('applyList').offsetTop - 90
        window.scrollTo(0, position)
      },
      applyBizcare (type) {
        const vm = this
        const applicant = vm.applicant
        let data = {}

        // 신청정보
        data.name = applicant.name
        data.contact = applicant.contact

        // 단일, 통합 유지관리 신청 타입에 따라 데이터 Set
        if (type === 'single') {
          data.single_service = vm.setServiceData(vm.checkedSingleService)
        } else {
          data.integrated_service = vm.setServiceData(vm.checkedIntegratedService)
        }

        // 비즈케어 신청 API 호출
        vm.loaderActive = true
        api.applyBizcare(data, response => {
          if (response.error) {
            // 신청 실패 시
            vm.loaderActive = false
            vm.showToastMessage('비즈케어 신청실패')
          } else {
            // 신청 완료 시, 데이터 초기화
            vm.loaderActive = false
            vm.checkedSingleService = []
            vm.checkedIntegratedService = []

            vm.scrollToApplyList()
            vm.$refs.grid.refresh()
            vm.showToastMessage('비즈케어 신청완료')
          }
        })
      }
    },
    created () {
      this.setApplicantInfo()
    }
  }
</script>

<style lang="scss" scoped>
  $pale-grey: #f8f9fa;
  $active-color: #9b88e9;

  #care {
    word-break: keep-all;

    h1, h2, h3, h4, h5 {
      font-weight: bold;
      color: $header-color;
    }

    ul, li {
      list-style: none;
    }

    form {
      margin-top: 24px;

      label {
        display: block;
        margin-bottom: 16px;
        color: $blue-grey;
      }

      input {
        width: 100%;
      }
    }

    button {
      width: 167px;
      @media (max-width: 767px) { width: 100%; }
    }

    .section-title {
      margin: 0 0 16px;
      font-size: 40px;
      line-height: 1.25;
      letter-spacing: -2.42px;
      text-align: center;

      br {
        display: none;
      }

      @media (max-width: 767px) {
        font-size: 32px;
      }
    }

    .notice {
      margin-bottom: 24px;
      text-align: center;

      img {
        display: inline-block;
        margin-top: -2px;
      }

      p {
        display: inline-block;
        margin: 0 0 0 8px;
        line-height: 1.57;
        letter-spacing: -0.58px;
        text-align: center;
        color: $blue-grey;
      }
    }

    .is-invalid-text {
      margin: 4px 0 0;
    }

    #hero {
      min-height: 333px;
      padding: 90px 16px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50% 100%;
      background-image: url("~@/assets/img/care/bg-care-hero.jpg");
      text-align: center;

      .title {
        margin: 0;
        font-size: 48px;
        line-height: 1.25;
        letter-spacing: -2.35px;
        color: $pale-grey;
      }

      p {
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
        letter-spacing: -1.3px;
        text-align: center;
        color: $orange;
      }

      @media (max-width: 767px) {
        min-height: 237px;
        padding: 40px 16px;
        background-position: 100% 100%;
        background-image: url("~@/assets/img/care/bg-care-hero-xs.jpg");

        .title {
          font-size: 32px;
        }
      }

      @media (max-width: 366px) {
        .title br {
          display: none;
        }
      }
    }

    #single {
      padding: 100px 0;
      background-color: $pale-grey;

      .table {
        display: table;
        position: relative;
        height: 82px;
        padding: 0 32px;
        margin-bottom: 16px;
        border-radius: 4px;
        border: 2px solid transparent;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        background-color: $hzc-white;
        cursor: pointer;

        &.active,
        &:hover {
          border: 2px solid $light-purple;
        }
      }

      .table-cell {
        display: table-cell;
        vertical-align: middle;
      }

      .checkbox {
        width: 10%;

        label { padding: 0; }
        .cr { margin: 6px 36px 0 0; }
      }

      .name {
        width: 30%;
        margin: 0;
        font-size: 26px;
        line-height: 1.31;
        letter-spacing: -1px;
      }

      .description {
        width: 70%;
        margin: 0;
        line-height: 1.57;
        letter-spacing: -0.58px;
        color: $blue-grey;
      }

      @media (max-width: 767px) {
        padding: 40px 8px;

        .table {
          padding: 16px 24px;
        }

        .name, .description {
          display: block;
          width: 100%;
        }

        .name {
          margin-bottom: 4px;
          font-size: 20px;
        }
      }
    }

    #integrated {
      padding: 100px 0 52px;

      @media (max-width: 767px) {
        padding: 40px 8px 20px;
      }

      li { margin-bottom: 16px; }

      .card {
        border-radius: 4px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        cursor: pointer;

        &:hover,
        &.active {
          margin: -2px;
          border: 2px solid $light-purple;
        }
      }


      .line {
        width: calc(100% - 48px);
        margin: auto;
        border-bottom: 1px solid #dee2e5;
      }

      .card-header {
        padding: 24px 24px;
        text-align: center;

        .checkbox {
          margin: 0 0 18px;
        }

        .icon img {
          margin: auto;
        }

        .contents {
          text-align: center;

          h4 {
            margin: 0 0 4px 0;
            font-size: 26px;
            line-height: 1.31;
            letter-spacing: -1px;
            color: $font-color;
          }

          p {
            margin-bottom: 0;
            line-height: 1.57;
            letter-spacing: -0.58px;
            color: $blue-grey;
          }
        }

        @media (max-width: 767px) {
          display: table;
          width: 100%;

          >div {
            display: table-cell;
            vertical-align: middle;
          }

          .checkbox {
            margin: 0;
            text-align: left;
          }

          .checkbox >label {
            width: 24px;
            padding: 0;
          }

          .checkbox .cr {
            margin-right: 16px;
          }

          .icon {
            width: 82px;
          }

          .icon >img {
            width: 50px;
            height: 50px;
          }

          .contents {
            padding-left: 16px;
            text-align: left;
          }

          .contents >p {
            margin: 0;
          }
        }
      }

      .card-body {
        position: relative;
        padding: 0 24px;

        p {
          margin-bottom: 4px;
          line-height: 1.57;
          letter-spacing: -0.58px;
          color: $blue-grey;

          &:first-child {
            margin-top: 16px;
          }
        }

        .bold {
          font-size: 16px;
          font-weight: bold;
          color: $font-color;
        }

        .options {
          position: absolute;
          bottom: 0;
          left: 0;
          padding: 16px 24px;
          background-color: $pale-grey;
        }

        // screen > md size
        @media (min-width: 992px) {
          display: block;
          height: 454px !important;
        }

        // screen < xs size
        @media (max-width: 991px) {
          .options {
            position: initial;
            margin: 0 -24px;
          }
        }
      }

      .card-footer {
        display: none;
        text-align: center;

        >a {
          position: relative;
          display: block;
          padding: 16px 0;
          font-size: 14px;
          font-weight: bold;
          line-height: 1.43;
          letter-spacing: -0.35px;
          color: $font-color;
          text-decoration: none;
        }

        img {
          position: absolute;
          top: 19px;
          right: calc(50% - 57px);
        }

        .bg-pale-grey {
          background-color: $pale-grey;
        }

        @media (max-width: 991px) {
          display: block;
        }
      }
    }

    #banner {
      margin-bottom: 52px;
      padding: 0 16px;
      text-align: center;

      @media (min-width: 768px) {
        .img-large { display: initial; }
        .img-small { display: none; }
      }

      @media (max-width: 767px) {
        .img-large { display: none; }
        .img-small { display: initial; }
      }
    }

    #applyList {
      padding: 0 0 100px;

      @media (max-width: 767px) {
        padding:0 8px 40px;
      }

      h4 {
        margin: 0 0 24px;
        font-size: 22px;
        font-weight: bold;
        line-height: 1.18;
        letter-spacing: -1.1px;
        color: $header-color;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/onm/care.vue